/*
 * Mega menu usability layer (desktop >= 990px only; mobile uses the drawer).
 *  - hover-intent: short delay before opening/closing so a diagonal mouse move
 *    toward the panel doesn't close it
 *  - click / tap / Enter / Space on a top-level item pins the panel open
 *  - Esc, click outside, or opening another item closes it
 *  - "Shop all" link injected so the top-level link can act as a toggle
 * Progressive enhancement: adds html.mm-enhanced only when it runs, so the
 * original CSS :hover behaviour remains if this script fails to load.
 */
(function () {
  var nav = document.querySelector('.custom_header__inline-menu');
  if (!nav) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 280;

  var items = Array.prototype.slice.call(nav.querySelectorAll('li.main_menu_item')).filter(function (li) {
    return li.querySelector('.mega_menu_items_wrapper');
  });
  if (!items.length) return;

  var lastClosedAt = 0;
  var openItem = null;
  var pinned = false;
  var openTimer = null;
  var closeTimer = null;

  items.forEach(function (li, i) {
    var link = li.querySelector(':scope > a');
    var panel = li.querySelector('.mega_menu_items_wrapper');
    var id = 'mega-panel-' + i;
    panel.id = id;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    link.setAttribute('aria-controls', id);

    // "Shop all <title>" so the parent page stays reachable
    var list = panel.querySelector('.child_menu_links');
    var href = (link.getAttribute('href') || '').trim();
    var hasLanding = href && href !== '#' && href.indexOf('javascript:') !== 0;
    link.dataset.mmLanding = hasLanding ? '1' : '';
    if (list && hasLanding && !panel.querySelector('.mm-shop-all')) {
      var all = document.createElement('li');
      all.className = 'mm-shop-all';
      var a = document.createElement('a');
      a.href = link.getAttribute('href');
      a.textContent = 'Shop all ' + link.textContent.trim().toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }) + ' →';
      all.appendChild(a);
      list.insertBefore(all, list.firstChild);
    }
  });

  function setOpen(li, on) {
    if (!li) return;
    li.classList.toggle('is-open', on);
    var a = li.querySelector(':scope > a');
    if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.classList.toggle('mm-open', !!(on || openItem && openItem !== li));
  }

  function open(li, pin) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (openItem && openItem !== li) setOpen(openItem, false);
    openItem = li;
    pinned = !!pin;
    setOpen(li, true);
  }

  function close() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (openItem) { setOpen(openItem, false); lastClosedAt = Date.now(); }
    openItem = null;
    pinned = false;
    document.documentElement.classList.remove('mm-open');
  }

  function scheduleClose() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (pinned) return;
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  function enable() {
    document.documentElement.classList.add('mm-enhanced');
  }
  function disable() {
    close();
    document.documentElement.classList.remove('mm-enhanced');
  }
  function sync() { desktop.matches ? enable() : disable(); }
  (desktop.addEventListener ? desktop.addEventListener('change', sync) : desktop.addListener(sync));
  sync();

  items.forEach(function (li) {
    var link = li.querySelector(':scope > a');

    li.addEventListener('mouseenter', function () {
      if (!desktop.matches || !finePointer.matches) return;
      clearTimeout(closeTimer);
      if (openItem === li) return;
      // switching between menus is instant; first open waits a beat
      if (openItem || Date.now() - lastClosedAt < 500) { open(li, false); return; }
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(li, false); }, OPEN_DELAY);
    });

    li.addEventListener('mouseleave', function () {
      if (!desktop.matches || !finePointer.matches) return;
      clearTimeout(openTimer);
      if (openItem === li) scheduleClose();
    });

    // Click / tap toggles (and pins). Touch tablets >= 990px get the same.
    link.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      var isOpen = openItem === li;
      if (isOpen && pinned && link.dataset.mmLanding) {
        // second click on the title goes through to the collection page
        return;
      }
      if (isOpen && pinned) { e.preventDefault(); close(); return; }
      e.preventDefault();
      open(li, true);
    });

    // Keyboard: Space opens; Enter on first press opens (second follows link)
    link.addEventListener('keydown', function (e) {
      if (!desktop.matches) return;
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        openItem === li && pinned ? close() : open(li, true);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(li, true);
        var first = li.querySelector('.mm-shop-all a, .child_menu_item a');
        if (first) first.focus();
      }
    });

    // Keep panel open while keyboard focus is inside it
    li.addEventListener('focusin', function () {
      if (!desktop.matches) return;
      if (openItem !== li && li.querySelector('.mega_menu_items_wrapper a:focus')) open(li, true);
    });
    li.addEventListener('focusout', function (e) {
      if (!desktop.matches || !pinned || openItem !== li) return;
      if (!li.contains(e.relatedTarget)) close();
    });
  });

  // Child rows: show matching preview image on focus too (hover already handled
  // by the theme snippet)
  nav.addEventListener('focusin', function (e) {
    var row = e.target.closest && e.target.closest('.child_menu_item');
    if (!row) return;
    var handle = row.getAttribute('data-handle');
    var scope = row.closest('.mega_menu_items_wrapper');
    if (!handle || !scope) return;
    var imgs = scope.querySelectorAll('.meg-img');
    var match = scope.querySelector('.image-for-' + handle);
    if (!match) return;
    Array.prototype.forEach.call(imgs, function (n) { n.classList.remove('active'); n.style.display = 'none'; });
    match.classList.add('active');
    match.style.display = 'block';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var li = openItem;
      close();
      var a = li.querySelector(':scope > a');
      if (a) a.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (openItem && !nav.contains(e.target)) close();
  });
  // Touch outside the header
  document.addEventListener('touchstart', function (e) {
    if (openItem && !nav.contains(e.target)) close();
  }, { passive: true });
})();
